import "bootstrap/dist/css/bootstrap.min.css";
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { StyledEngineProvider } from '@mui/material/styles';


require('./firebase')

// const language = navigator.language.split("-")[0] || navigator.userLanguage.split("-")[0] || "en";
// const country = navigator.language.split("-")[1] || navigator.userLanguage.split("-")[1] || "us";


ReactDOM.render(
  <React.StrictMode>
    {/* StyledEngineProvider as mui !important */}
    <StyledEngineProvider injectFirst>
      <App />
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

